import { HStack } from '@chakra-ui/react';
import React from 'react';

import { TAccountTypeGQLType } from '../../../../types/dashboard-core-gqlTypes.generated.d';
import { IsolatedMultiSelect } from 'packages/common-frontend/components/MultiSelect';

type ExpensesFeesFilterMenuProps = {
  onChange: {
    accountTypes: React.Dispatch<
      React.SetStateAction<[] | TAccountTypeGQLType[]>
    >;
    countersigners: React.Dispatch<React.SetStateAction<[] | string[]>>;
  };
  options: {
    accountTypes: {
      label: string;
      value: TAccountTypeGQLType;
    }[];
    countersigners: { label: string; value: string }[];
  };
  selectedOptions: {
    accountTypes: TAccountTypeGQLType[] | [];
    countersigners: string[];
  };
};

export const ExpensesFeesFilterMenus = ({
  onChange,
  options,
  selectedOptions,
}: ExpensesFeesFilterMenuProps) => {
  if (!options || options.accountTypes.length === 0) {
    return null;
  }

  return (
    <HStack spacing="1rem">
      <IsolatedMultiSelect
        applyButtonText="Apply filters"
        buttonProps={{ minWidth: '250px' }}
        counterLabel="Accounts"
        initialSelections={selectedOptions.accountTypes}
        isSearchable
        optionsHeader="Accounts"
        options={options.accountTypes}
        onApplyOptions={(val) => onChange.accountTypes(val)}
        placeholderText="Select accounts"
        showSelectedCount
        titleText="All accounts"
      />
      <IsolatedMultiSelect
        applyButtonText="Apply filters"
        buttonProps={{ minWidth: '250px' }}
        counterLabel="Countersigners"
        initialSelections={selectedOptions.countersigners}
        isSearchable
        onApplyOptions={(val) => onChange.countersigners(val)}
        options={options.countersigners}
        optionsHeader="Countersigners"
        placeholderText="Select countersigners"
        showSelectedCount
        titleText="All countersigners"
      />
    </HStack>
  );
};
